import * as allLanguages from 'all-iso-language-codes';

interface ILists {
  label: string;
  value: string;
  disabled?: boolean;
}

export interface ILanguage {
  label: string;
  value: string;
  nativeName?: string;
}

export const preferredLanguageByLocation = {
  'NY': ['English', 'Spanish',
    'Chinese',
    'Bengali',
    'Russian',
    'Arabic',
    'French',
    'Punjabi',
    'Urdu',
    'Hindi',
    'Nepali',
    'Korean',],
  'IL': ['English', 'Spanish', 'Chinese', 'French', 'Russian', 'Punjabi', 'Hindi', 'Bengali', 'Urdu', 'Arabic', 'Polish', 'Talog', 'Burmese'],
  'NJ': ['English', 'Spanish', 'Portuguese', 'French', 'Russian', 'Punjabi', 'Hindi', 'Bengali', 'Urdu', 'Arabic', 'Turkish', 'Chinese'],
  'CT': ['English', 'Spanish', 'Chinese', 'French', 'Russian', 'Punjabi', 'Hindi', 'Bengali', 'Urdu', 'Arabic', 'Turkish', 'Persian'],
}


export const generateLanguageList = (location: 'NY' | 'NJ' | 'IL' | 'CT' | undefined): Array<ILanguage> => {
  const priorityLanguages = typeof location !== 'undefined' ? preferredLanguageByLocation[location] : []

  const languages: Array<ILanguage> = [];
  const priorityLangs: Array<ILanguage> = [];
  const remainingLangs: Array<ILanguage> = [];

  const isoCodes = allLanguages.getAll639_1();

  isoCodes.forEach((code: string) => {
    const englishName = allLanguages.getEnglishName(code);
    const nativeName = allLanguages.getNativeName(code);

    if (englishName) {
      const langObj = {
        label: englishName,
        value: code,
        nativeName: nativeName || englishName,
      };

      if (priorityLanguages?.includes(englishName)) {
        priorityLangs.push(langObj);
      } else {
        remainingLangs.push(langObj);
      }
    }
  });

  priorityLangs.sort((a, b) => {
    return priorityLanguages?.indexOf(a.label) - priorityLanguages?.indexOf(b.label);
  });

  remainingLangs.sort((a, b) => a.label.localeCompare(b.label));

  languages.push(...priorityLangs, ...remainingLangs);

  languages.push({
    label: 'Other',
    value: 'other',
    nativeName: 'Other',
  });

  return languages;
};

export const preferredLanguageList: Array<ILanguage> = generateLanguageList(undefined);

export const genderList: Array<ILists> = [
  { label: 'Select Gender', value: '', disabled: true },
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Prefer not to say', value: 'Prefer not to say' },
];

export const reasonsForVisit: Array<ILists> = [
  { label: 'Select reason for your visit', value: '', disabled: true },
  { label: 'Tickets', value: 'Tickets' },
  { label: 'Class', value: 'Class' },
  { label: 'Deactivation', value: 'Deactivation' },
  { label: 'Wellness', value: 'Wellness' },
  { label: 'Benefits', value: 'Benefits' },
  { label: 'Other', value: 'other' },
];
